<template>
  <!-- virtualPowerPlant2 -->
  <div class="kanbanContainer">
    <div class="kanBanTop flexBetween1">
      <div class="topLeft" style="width: 25%">
        <div class="left-1" style="background:#81C5FF40">
          <P class="titleText">碳排放</P>
          <div style="height: 200px;">
            <div class="box_t">
              <div class="tt">
                <img src="../../../public/static/image/dekan/gffdl.png?n=1" style="width: 3vw;margin-bottom: 5px;">
                <p style="font-size: .13rem;">光伏发电量</p>
                <div>
                  <span>{{zongVal}}</span>
                  <span>kWh</span>
                </div>
              </div>
              <div class="tt">
                <img src="../../../public/static/image/dekan/cdzydl.png" style="width: 3vw;margin-bottom: 5px;">
                <p style="font-size: .13rem;">充电桩用电量</p>
                <div>
                  <span>{{chargingVal}}</span>
                  <span>kWh</span>
                </div>
              </div>
              <div class="tt" style="margin: 0;">
                <img src="../../../public/static/image/dekan/CO2jpl.png" style="width: 3vw;margin-bottom: 5px;">
                <p style="font-size: .13rem;">CO2减排量</p>
                <div>
                  <span>{{zongVal | coCount}}</span>
                  <span>t</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="left-2" style="background:#81C5FF40;margin-top: 10px;">
          <p class="titleText">光伏数据</p>
          <vchart ref="voption2" style="height: 200px;"></vchart>
        </div>

        <div class="left-3" style="background:#81C5FF40;margin-top: 10px;position: relative;
                    height: 200px;">
          <p class="titleText">储能电量</p>
          <div slass="bg">
            <div class="heng"></div>
            <div class="shu"></div>
          </div>
          <div class="box">
            <div class="li">
              <img src="../../../public/static/image/dekan/syrl.png">
              <div class="r">
                <div class="num">{{cnData.shengyurongliang}} %</div>
                <div class="txt">SOC</div>
              </div>
            </div>
            <div class="li">
              <img src="../../../public/static/image/dekan/3.png">
              <div class="r">
                <div class="num">{{cnData.dccfdgl}}kW</div>
                <div class="txt">当前功率</div>
              </div>
            </div>
            <div class="li">
              <img src="../../../public/static/image/dekan/zfdl.png">
              <div class="r">
                <div class="num">{{cnData.zmdl}}MWh</div>
                <div class="txt">总放电量</div>
              </div>
            </div>
            <div class="li">
              <img src="../../../public/static/image/dekan/zcdl.png">
              <div class="r">
                <div class="num">{{cnData.zndl}}MWh</div>
                <div class="txt">总充电量</div>
              </div>
            </div>
          </div>
        </div>

        <div class="left-3" style="background:#81C5FF40;margin-top: 10px;display: none;">
          <p class="titleText">储能电量</p>
          <div>
            <div></div>
          </div>
          <div class="dianliang flexBetween1">
            <div class="dianchi" style="padding-left: 30px;">
              <div class="dianchimao"></div>
              <div class="chisheng">
                <div class="rongliang" ref="rongliang">{{cnData.shengyurongliang}}%</div>
                <div class="beijingse"></div>
              </div>
            </div>
            <div class="dianchiState" style="width: 60%;margin-top: 10px;">
              <div class="stateText">
                <span>当前工作模式:</span>
                <span v-if="cnData.daiji == 1 && cnData.fadian == 0 && cnData.fangdian == 0"
                  style="color: #21ef70;margin-left: 30px;">待机</span>
                <span v-if="cnData.fadian == 1 && cnData.fangdian == 0 "
                  style="color: #21ef70;margin-left: 30px;">充电中</span>
                <span v-if="cnData.fangdian == 1 && cnData.fadian == 0 "
                  style="color: #21ef70;margin-left: 30px;">放电中</span>
                <span v-if="cnData.fadian == 1 && cnData.fangdian == 1 "
                  style="color: #21ef70;margin-left: 30px;">充电/放电中</span>
              </div>
              <div class="stateText" style="margin-top: 30px;">
                <span>日储能电量:</span>
                <span style="color: #21ef70;margin-left: 30px;">{{cnData.maidianliang}}kWh</span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="topMid" style="width: 48%">
        <div class="plantInfo flexBetween1" style="width: 90%;margin: 0 auto;padding-top: 30px;">
          <div class="leftInfo" style="width: 49%">
            <div class="leftInfoTop flexBetween1">
              <div class="yongdianliang" style="width: 48%">
                <p class="topP">年度总用电</p>
                <p class="bottomP">{{yearPower}}kWh</p>
              </div>
              <div class="yongdianliang" style="width: 48%">
                <p class="topP">当月总用电</p>
                <p class="bottomP">{{monPower}}kWh</p>
              </div>
            </div>
            <div class="leftBottom" style="height: 100px;">
              <p style="padding-bottom: 20px;">总体能耗</p>
              <div>
                <span>当日总用电量:</span>
                <span style="margin-left: 30px;font-size:16px;">{{dayPower}}</span>
                <span style="margin-left: 20px">kWh</span>
              </div>
              <div style="margin-top: 20px;">
                <span>实时功率:</span>
                <span style="margin-left: 30px;font-size:16px;">{{random(110)}}</span>
                <span style="margin-left: 20px">KW</span>
              </div>
            </div>
          </div>
          <div class="rightInfo" style="width: 49%">
            <div class="leftInfoTop flexBetween1">
              <div class="yongdianliang" style="width: 48%">
                <p class="topP">月最大负荷</p>
                <p class="bottomP">{{monfuhe}}W</p>
              </div>
              <div class="yongdianliang" style="width: 48%">
                <p class="topP">日最大负荷</p>
                <p class="bottomP">{{dayfuhe}}W</p>
              </div>
            </div>
            <div class="leftBottom" style="height: 100px;">
              <p style="padding-bottom: 20px;">碳排放</p>
              <div>
                <span>CO2减排量:</span>
                <span style="margin-left: 30px;font-size:16px;">{{yearPower | coCount}}</span>
                <span style="margin-left: 20px;">t</span>
              </div>
              <div style="display: none">
                <span>当日节能控制时间:</span>
                <span style="margin-left: 30px;font-size:16px;">1.3</span>
                <span style="margin-left: 20px;">小时</span>
              </div>
              <div style="margin-top: 20px;display: none">
                <span>当日节能能耗:</span>
                <span style="margin-left: 30px;font-size:16px;">4.1</span>
                <span style="margin-left: 20px;">kWh</span>
              </div>
            </div>
          </div>
        </div>
        <div class="plantImg" style="width: 100%;height: 403px;margin-top:60px;">
          <iframe id="my_iframe" src="static/3d/scene.html"></iframe>
          <div id="layer">
            <div id="text">
              <div v-show="showZJRL" style="font-size: 14px;">装机容量:{{ZJRLData}}KW</div>
              <div v-show="showAkr">
                <div v-for="(item,index) in showAkrData" style="font-size: 14px;">第{{index+1}}路开关:{{item}}</div>
              </div>
              <div v-show="showStar">
                <div v-for="item in showStarData" style="font-size: 14px;">{{item.status}}:{{item.text}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="topRight" style="width: 25%;background:#81C5FF40">
        <div style="display: flex;justify-content: start;padding: 10px 0 0 30px;">
          <div class="rightTopTab" :class="{'active':indexed===1}" @click="changeTopTab(1)">
            <div class="rightTopTab1">电瓶车</div>
          </div>
          <div class="rightTopTab" style="margin-left: 10px;" :class="{'active':indexed===2}" @click="changeTopTab(2)">
            <div class="rightTopTab1">电动车</div>
          </div>
          <!--                    <div class="rightTopTab" style="margin-left: 10px;" :class="{'active':indexed===3}" @click="changeTopTab(3)">-->
          <!--                        <div class="rightTopTab1">储能</div>-->
          <!--                    </div>-->
        </div>
        <div class="showImportantInfo" v-show="indexed == 1">
          <p style="margin: 35px 0 20px 30px;">运行统计</p>
          <div style="display: flex;width:270px;margin: 0 auto;flex-wrap: wrap;">
            <!--                    <div style="margin: 10px;">-->
            <div style="margin: 10px; width:110px;height: 110px;border: 1px solid #368ed9;border-radius: 50%;">
              <div style="width: 50px;height: 50px;margin: 0 auto;padding-top: 5px;">
                <img src="../../../public/static/image/dekan/cdzzs.png" style="width: 100%">
              </div>
              <p style="text-align: center;margin-top: 15px;">充电桩总数</p>
              <div style="text-align: center">
                <span>2</span>
                <span>个</span>
              </div>
            </div>

            <div style="margin: 10px; width:110px;height: 110px;border: 1px solid #368ed9;border-radius: 50%;">
              <div style="width: 50px;height: 50px;margin: 0 auto;padding-top: 5px;">
                <img src="../../../public/static/image/dekan/zysl.png" style="width: 100%">
              </div>
              <p style="text-align: center;margin-top: 15px;">在用数量</p>
              <div style="text-align: center">
                <span>10</span>
                <span>个</span>
              </div>
            </div>

            <div style="margin: 10px; width:110px;height: 110px;border: 1px solid #368ed9;border-radius: 50%;">
              <div style="width: 50px;height: 50px;margin: 0 auto;padding-top: 5px;">
                <img src="../../../public/static/image/dekan/gzs.png" style="width: 100%">
              </div>
              <p style="text-align: center;margin-top: 15px;">故障数</p>
              <div style="text-align: center">
                <span>0</span>
                <span>个</span>
              </div>
            </div>
            <div style="margin: 10px; width:110px;height: 110px;border: 1px solid #368ed9;border-radius: 50%;">
              <div style="width: 50px;height: 50px;margin: 0 auto;padding-top: 5px;">
                <img src="../../../public/static/image/dekan/cdzzs.png" style="width: 100%">
              </div>
              <p style="text-align: center;margin-top: 15px;">日累积电量</p>
              <div style="text-align: center">
                <span>4</span>
                <span>kWh</span>
              </div>
            </div>

          </div>
          <p style="margin: 55px 0 30px 30px;">充电桩运行曲线</p>
          <vchart ref="voption3" style="height: 200px;"></vchart>
        </div>
        <div class="showImportantInfo" v-show="indexed == 2">
          <p class="infoTitle">运行统计</p>
          <div class="infoContent">
            <div class="infoItem">
              <div class="infoItemImg">
                <img src="../../../public/static/image/dekan/ddczs.png">
              </div>
              <p>充电桩总数</p>
              <div>
                <span>15</span>
                <span>个</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img src="../../../public/static/image/dekan/ljfdl1.png">
              </div>
              <p>充电使用</p>
              <div>
                <span>3</span>
                <span>个</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img src="../../../public/static/image/dekan/drfdl.png">
              </div>
              <p>地锁使用</p>
              <div>
                <span>1</span>
                <span>个</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img src="../../../public/static/image/dekan/gzs.png">
              </div>
              <p>停车位使用</p>
              <div>
                <span>7</span>
                <span>个</span>
              </div>
            </div>
          </div>

        </div>
        <div class="showImportantInfo" v-show="indexed == 3">
          <p class="infoTitle">储能运行统计</p>
          <div class="infoContent">
            <div class="infoItem">
              <div class="infoItemImg">
                <img
                  src="data:image/png;base64,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">
              </div>
              <p>电池温度</p>
              <div>
                <span>{{cnData.dianciwendu}}</span>
                <span>℃</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img
                  src="data:image/png;base64,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">
              </div>
              <p>当天发电量</p>
              <div>
                <span>{{cnData.dangtianfadianliang}}</span>
                <span>kWh</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img
                  src="data:image/png;base64,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">
              </div>
              <p>当天买电量</p>
              <div>
                <span>{{cnData.maidianliang}}</span>
                <span>kWh</span>
              </div>
            </div>
            <div class="infoItem">
              <div class="infoItemImg">
                <img
                  src="data:image/png;base64,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">
              </div>
              <p>当天卖电量</p>
              <div>
                <span>{{cnData.dangtianmaidianliang}}</span>
                <span>kWh</span>
              </div>
            </div>
          </div>
          <p class="infoTitle">电池充放电负荷曲线</p>
          <vchart ref="voption7" style="height: 200px"></vchart>
        </div>

      </div>
    </div>
    <div class="kanBanBottom flexBetween1" style="margin-top: 10px;margin-bottom: 20px;">
      <div style="width: 25%;background:#81C5FF40">
        <!--                <div class="left-1" style="background:#81C5FF40">-->
        <p class="titleText">用能数据</p>
        <vchart ref="voption1" style="height: 300px;"></vchart>
        <!--                <div>-->
      </div>
      <div class="bottomLeft flexBetween1" style="width: 48%;background:#81C5FF40">
        <div style="width: 100%">
          <p class="titleText">电站日发电量查询</p>
          <p style="font-size: 12px;text-align: right">日发电量/kwh</p>
          <vchart ref="voption4" style="height: 120px;"></vchart>

          <p class="titleText">电站月发电量查询</p>
          <p style="font-size: 12px;text-align: right">月发电量/kwh</p>
          <vchart ref="voption5" style="height: 120px;"></vchart>
        </div>
        <!--                <div style="width: 30%;">-->
        <!--                    <p class="titleText" style="margin-bottom: 20px;">电站概况</p>-->
        <!--                    <div class="flexBetween1">-->
        <!--                        <div style="width: 60%; margin-left: 10%;">-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>月二氧化碳减排量:{{carbon}}吨</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>月二氧化硫减排量:{{sulfur}}吨</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>光伏环境温度:{{dnData.wendu}}℃</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>光伏列阵面积:{{plantParams.gfmianji}}㎡</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>逆变器数量: {{ nowVariableName.gf.length}}</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>光伏组件数量: {{plantParams.gfzhujian}}</span>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div style="width: 40%">-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>辐照: {{plantParams.fuzhao}}W/㎡</span>-->
        <!--                            </div>-->
        <!--                            <div class="bottomText">-->
        <!--                                <span>倾斜度:{{plantParams.qingxiejiao}}°</span>-->
        <!--                            </div>-->
        <!--&lt;!&ndash;                            <div class="bottomText">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span>环境温度: 20℃</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="bottomText">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span>湿度: 48.1</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="bottomText">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span>风向: 西北</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="bottomText">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span>风速: 2.41m/s</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>
      <div class="bottomRight" style="width: 25%;background:#81C5FF40;">
        <p class="titleText">安全告警</p>
        <vchart ref="voption6" style="height: 200px;"></vchart>
        <div class="flexBetween1" style="width: 80%; margin: 0 auto;padding-top: 20px;">
          <div class="gaojingLeft flexBetween1" style="width: 40%;height: 60px;text-align: center;
                    padding: 15px 0;flex-direction: column;border:1px solid #368ed9">
            <div style="font-size: 20px;color: #368ed9;">{{190}}</div>
            <div>总告警数</div>
          </div>
          <div class="gaojingRight flexBetween1"
            style="width: 50%;text-align: left;flex-direction: column;height: 92px;">

            <div class="flexBetween1" style="border:1px solid #368ed9">
              <div style="width:50%;margin-left: 5px;">预警</div>
              <div style="width:50%">{{123}}</div>
            </div>
            <div class="flexBetween1" style="border:1px solid #368ed9">
              <div style="width:50%;margin-left: 5px;">告警</div>
              <div style="width:50%">{{67}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vchart from "../../components/module/chart/vchart";
  import store from "../../cache/virtualPowerPlantStore";
  //import fbx from "../../../public/static/fbx/ship.fbx"
  export default {
    components: {
      vchart,
      //fbx
    },
    data () {
      return {
        fadianQuxian: [],

        monfuhe: "",//当月最大负荷
        dayfuhe: "",//当日最大负荷
        chargingVal: "",//充电桩用电量
        zongVal: "",//光伏总发电量
        eventList: [
          {
            "no": 6944,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712717345000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6943,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712717342000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯中断",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6942,
            "type": 7,
            "linkobject": "devicestate.古瑞瓦特设备",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712700810000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成宾赫光伏`  古瑞瓦特设备 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "宾赫光伏项目",
            "unitId": "DFEB960FF9914974A95B458A78A86007",
            "deviceNo": 6,
            "deviceName": "古瑞瓦特设备"
          },
          {
            "no": 6941,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712673639000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6940,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712673637000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯中断",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6939,
            "type": 7,
            "linkobject": "devicestate.古瑞瓦特设备",
            "confirmtime": 1712670673000,
            "confirmuser": "1",
            "time": 1712660400000,
            "eventstate": 3,
            "eventlevel": 0,
            "description": "数据采集通道`华成宾赫光伏`  古瑞瓦特设备 通讯中断",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "宾赫光伏项目",
            "unitId": "DFEB960FF9914974A95B458A78A86007",
            "deviceNo": 6,
            "deviceName": "古瑞瓦特设备"
          },
          {
            "no": 6938,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712641332000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6937,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712641329000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯中断",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          },
          {
            "no": 6936,
            "type": 7,
            "linkobject": "devicestate.古瑞瓦特设备",
            "confirmtime": 1712670672000,
            "confirmuser": "1",
            "time": 1712613532000,
            "eventstate": 3,
            "eventlevel": 0,
            "description": "数据采集通道`华成宾赫光伏`  古瑞瓦特设备 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "宾赫光伏项目",
            "unitId": "DFEB960FF9914974A95B458A78A86007",
            "deviceNo": 6,
            "deviceName": "古瑞瓦特设备"
          },
          {
            "no": 6935,
            "type": 7,
            "linkobject": "devicestate.充电桩电表",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712589668000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`华成电力`  充电桩电表 通讯恢复",
            "linkdevice": -858993460,
            "typeName": "通信信息",
            "limitedColor": null,
            "unitName": "电变电站办公楼",
            "unitId": "A60E827715A34A0389B05AFA74AECD3C",
            "deviceNo": 5,
            "deviceName": "充电桩电表"
          }
        ],
        dnData: {},
        carbon: {},
        cnData: {
          shengyurongliang: this.random(0),
          dccfdgl: this.random(0),
          zmdl: this.random(110),
          zndl: this.random(110),
        },
        xxcdzInfo: {},
        sulfur: {},
        dayPower: 0,
        yearPower: 0,
        monPower: 0,
        showAkr: false,
        showStar: false,
        showAkrData: [],//安科瑞显示
        showStarData: [],//星星显示
        allCdzInfo: {no13: '',no10: ''},//全部充电桩状态信息
        showZJRL: false,
        ZJRLData: 0,
        akr: ['no1-1#电瓶车充电桩','no2-2#电瓶车充电桩','no3-3#电瓶车充电桩','no4-4#电瓶车充电桩'],//安科瑞
        star: ['no9-充电桩12307626','no10-充电桩12307905','no11-充电桩12308142','no12-充电桩10366223','no13-充电桩10388424'],//星星
        showDeviceData: [],
        dyfdl: 0,//当月发电量
        plantParams: {
          carbonValue: 0,//二氧化碳
          sulfurValue: 0,//二氧化硫
          gfmianji: 0,//光伏面积
          gfzhujian: 0,//光伏组件数量
          fuzhao: 0,//辐照
          qingxiejiao: 0//倾斜角
        },
        indexed: 1,
        cdzRunLine: [],
        maxMonthLoad: 0,
        maxDayLoad: 0,
        eventObj: {
          "allGjCount": 0, //总告警数
          "allCount": 0, //本月总数
          "allYjCount": 0,//总预警
        },
        yhfhLine: [],
        option1: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            name: "kW",
            splitNumber: 5,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          legend: {
            orient: 'vertical',
            color: '#fff',
            right: '5%',
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            top: '15%',
            left: '5%',
            bottom: '1%',
            containLabel: true
          },
          series: [
            {
              // name: '网供负荷',
              data: [],
              itemStyle: {
                normal: {
                  color: '#5f96f1',
                  lineStyle: {
                    color: '#5f96f1',
                    width: 3
                  }
                }
              },
              markPoint: {
                data: [
                  // {type: 'max',name: 'Max'},
                ],
                label: {
                  fontSize: 10
                },
                symbolSize: 40
              },
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },

          ]
        },
        option2: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['负荷','发电'],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            //max:50,
            name: "kW",
            splitNumber: 5,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          legend: {
            orient: 'vertical',
            color: '#fff',
            right: '5%',
            top: '5%',
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            top: '15%',
            left: '5%',
            bottom: '1%',
            containLabel: true
          },
          series: [
            {
              name: '负荷',
              data: [],
              itemStyle: {
                normal: {
                  color: '#5f96f1',
                  lineStyle: {
                    color: '#5f96f1',
                    width: 3
                  }
                }
              },
              markPoint: {
                // data: [
                //   {type: 'max',name: 'Max'},
                // ],
                label: {
                  fontSize: 10
                },
                symbolSize: 40
              },
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },
            {
              name: '发电',
              data: [],
              itemStyle: {
                normal: {
                  color: '#fe9611',
                  lineStyle: {
                    color: '#fe9611',
                    width: 3
                  }
                }
              },
              markPoint: {
                // data: [
                //   {type: 'max',name: 'Max'},
                // ],
                label: {
                  fontSize: 10
                },
                symbolSize: 40
              },
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },


          ]
        },
        option3: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              interval: 1,
              textStyle: {
                color: '#fff',
                fontSize: 9
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            //name: "kW",
            splitNumber: 5,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          legend: {
            orient: 'vertical',
            color: '#fff',
            right: '5%',
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            top: '5%',
            bottom: '5%',
            containLabel: true
          },
          series: [
            {
              //name:'网供负荷',
              data: [],
              itemStyle: {
                normal: {
                  color: '#5f96f1',
                  lineStyle: {
                    color: '#5f96f1',
                    width: 3
                  }
                }
              },
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },

          ]
          //series: this.cdzRunLine
        },
        option4: {
          tooltip: {
            trigger: 'axis',
          },
          color: ['#5f96f1'],
          xAxis: {
            type: 'category',
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                //fontSize:12
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            //设置网格线颜色
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            }
          },
          grid: {
            top: '5%',
            left: '1%',
            bottom: '3%',
            right: '1%',
            containLabel: true
          },
          series: [
            {
              data: [],
              type: 'bar'
            }
          ]
        },
        option5: {
          tooltip: {
            trigger: 'axis',
          },
          color: ['#fe9611'],
          xAxis: {
            type: 'category',
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                //fontSize:12
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            //设置网格线颜色
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            }
          },
          grid: {
            top: '5%',
            left: '1%',
            bottom: '3%',
            right: '1%',
            containLabel: true
          },
          series: [
            {
              data: [],
              type: 'bar',

            }
          ]
        },
        option6: {
          tooltip: {
            trigger: 'item',
          },
          //color:['#66FF99', '#f0cb32', '#f59447'],
          color: ['#66FF99','#f0cb32'],
          series: [
            {
              type: 'pie',
              radius: '60%',
              left: 100,
              data: [
                {value: 0,name: '预警'},
                {value: 0,name: '告警'},
                // {value: 26,name: '消息'}
              ],
              itemStyle: {
                normal: {
                  label: {
                    formatter: '{b}\n {d}%',
                    textStyle: {
                      color: '#fff',
                      fontSize: 14,
                    }
                  },
                }
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        },
        option7: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          yAxis: {
            type: 'value',
            //name: "kW",
            splitNumber: 5,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          },
          legend: {
            orient: 'vertical',
            color: '#fff',
            right: '5%',
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            top: '5%',
            left: '5%',
            bottom: '5%',
            containLabel: true
          },
          series: [
            {
              //name:'网供负荷',
              data: [0.10,0.14,0.12,0.19,0.31,0.52,0.68,0.45,0.65,0.54,0.23,0.36],
              itemStyle: {
                normal: {
                  color: '#5f96f1',
                  lineStyle: {
                    color: '#5f96f1',
                    width: 3
                  }
                }
              },
              type: 'line',
              symbol: 'none', //去掉折线图中的节点
              smooth: true
            },
          ]
          //series: this.cdzRunLine
        },
      }
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      cdzInfo () {
        return this.$store.plantStore.getters.getCdzShowData
      },

      nowVariableName () {
        return this.$store.plantStore.getters.getVariableNames
      },
      cnData () {
        return this.$store.plantStore.getters.getCnShowData
      },
      dnData () {
        return this.$store.plantStore.getters.getDnShowData
      },
      carbon () {
        return (Number(this.plantParams.carbonValue)*Number(this.dyfdl)).toFixed(2)
      },
      sulfur () {
        return (Number(this.plantParams.sulfurValue)*Number(this.dyfdl)).toFixed(2)
      }
    },
    watch: {
      nowUnit (ov,nv) {
        //removeTask('getRealTimeValue')

      },
      nowVariableName: {
        handler (nv,ov) {

        },
        deep: true
      },
      cnData (ov,nv) {
        this.changeHeight();
      }
    },
    mounted () {
      window.goToWhere=this.goToWhere;
      window.showDeviceInfo=this.showDeviceInfo;

      var timerArr=[]
      var timerArrMon=[]
      for(let i=0;i<24;i++) {
        timerArr.push(i>9? i+':00':"0"+i+':00')
      }
      let date=new Date();
      let year=date.getFullYear();      //年
      let month=date.getMonth()+1;    //月 

      let days=new Date(year,month+1,0).getDate()
      console.log(days,'days');
      for(let i=1;i<=days;i++) {
        timerArrMon.push(i)
      }
      this.option3.xAxis.data=timerArr
      this.option1.xAxis.data=timerArr
      this.option4.xAxis.data=timerArr
      this.option5.xAxis.data=timerArrMon
      this.option2.xAxis.data=timerArr
      //加载后启动一次  实时获取充电桩信息 
      this.getList()
      let gjSur=[];
      gjSur.push({
        type: 'pie',
        radius: '60%',
        left: 100,
        data: [
          {value: 123,name: '预警'},
          {value: 56,name: '告警'},
        ],
        itemStyle: {
          normal: {
            label: {
              formatter: '{b}\n {d}%',
              textStyle: {
                color: '#fff',
                fontSize: 14,
              }
            },
          }
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      })
      this.option6.series=gjSur;
      this.$refs.voption6.setData(this.option6)
      this.get3dDevicesInfo();
    },
    created () {
      debugPage=this
    },
    destroyed () {
      removeTask('getRealTimeValue')
    },
    methods: {
      //获取当月开始时间戳
      getMonTimer () {
        var endTimes=new Date().getTime();
        // 获取当前月份
        const month=new Date().getMonth();

        // 设置日期为当前月份的1号
        const date=new Date();
        date.setMonth(month);
        date.setDate(1);

        // 将时分秒都设置为0
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date.getTime()
      },
      //获取当年开始时间戳
      getYearTimer () {
        // 获取当前年份
        const year=new Date().getFullYear();

        // 设置日期为当年1月1日
        const date=new Date();
        date.setFullYear(year);
        date.setMonth(0); // 1月为0
        date.setDate(1);

        // 将时分秒都设置为0
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date.getTime()
      },
      //获取当日开始时间戳
      getDayTimer () {
        const date=new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date.getTime()
      },


      random (v) {
        var a=(Math.random()*100+parseInt(v)).toFixed(2)
        return a;
      },
      getList () {
        //当日最大负荷
        this.dayfuhe=this.random(90);
        //当月最大负荷
        this.monfuhe=this.random(150);
        var d={
          'unitId': this.unitId.id
        }
        const endTimes=new Date().getTime()

        // 获取当月开始时间戳
        const montimestamp=this.getMonTimer();
        //当月总用电量
        this.monPower=this.random(300);

        // 获取当年开始时间戳
        const yeartimestamp=this.getYearTimer();
        //当年总用电量
        this.yearPower=this.random(2000);
        // 获取当日开始时间戳
        const daytimestamp=this.getDayTimer();
        //当日总用电量
        this.dayPower=this.random(0);




        var newArr=[]

        var resArr=[]
        var num=0
        for(let i=0;i<24;i++) {
          num=0
          newArr.forEach(item => {
            console.log(item[i],'aaaaaaaa');
            if(item[i]==null) {
              num=0
            } else {
              num+=Number(item[i]);
            }
          });
          resArr.push(this.random(100))
        }


        this.option3.series[0].data=resArr;

        this.$refs.voption3.setData(this.option3)


        var newArr=[]

        var resArr=[]
        var num=0
        for(let i=0;i<24;i++) {
          num=0
          newArr.forEach(item => {
            if(item[i]==null) {
              num=0
            } else {
              num+=Number(item[i])
            }
          })
          resArr.push(this.random(0))
        }
        this.option1.series[0].data=resArr
        this.$refs.voption1.setData(this.option1)

        var dd={
          'dateType': "day",
          'unitId': this.unitId.id
        }
        var newArr=[]

        var resArr=[]
        var num=0
        for(let i=0;i<24;i++) {
          num=0
          newArr.forEach(item => {
            if(item[i]==null) {
              num=0
            } else {
              num+=Number(item[i])
            }
          })
          resArr.push(this.random(100))
        }
        this.option4.series[0].data=resArr
        this.fadianQuxian=resArr
        this.$refs.voption4.setData(this.option4)
        var newArrs=[]

        var resArrs=[]
        var nums=0
        for(let i=0;i<24;i++) {
          nums=0
          newArrs.forEach(item => {
            if(item[i]==null) {
              nums=0
            } else {
              nums+=Number(item[i])
            }
          })
          resArrs.push(this.random(90))
        }
        this.option2.series[0].data=resArrs
        this.option2.series[1].data=this.fadianQuxian
        this.$refs.voption2.setData(this.option2)
        var ddd={
          'dateType': "month",
          'unitId': this.unitId.id
        }
        var newArr=[];

        var resArr=[];
        var num=0;
        for(let i=0;i<24;i++) {
          num=0
          newArr.forEach(item => {
            if(item[i]==null) {
              num=0
            } else {
              num+=Number(item[i])
            }
          })
          // num.toFixed(2)
          resArr.push(this.random(1))
        }
        this.option5.series[0].data=resArr;
        this.$refs.voption5.setData(this.option5);



      },

      get3dDevicesInfo () {
        this.$api.plantApi.get3dDevicesInfo(this.akr.join(','),this.star.join(','),res => {
          this.allCdzInfo=res;
        })
      },
      showDeviceInfo (no) {
        this.showZJRL=false;
        this.showAkr=false;
        this.showStar=false;
        let deviceInfo='';
        //debugger;
        switch(no) {
          case 'no5':
            this.showZJRL=true;
            this.ZJRLData=this.dnData.bingwanggonglv;
            break;
          case 'no6':
            this.showZJRL=true;
            this.ZJRLData=10.24;
            break;
          default:
            deviceInfo=this.allCdzInfo[no];
            break;
        }
        if(no=='no1'||no=='no2'||no=='no3'||no=='no4') {
          //清空
          this.showAkrData=[];
          if(deviceInfo!='') {
            let strArr=[];
            strArr=deviceInfo.split(';');
            strArr.forEach(item => {
              let a=item.split(':')[0];
              if(a=='0') {
                this.showAkrData.push('空闲');
              } else {
                this.showAkrData.push('使用');
              }
            })
            //显示
            this.showAkr=true;
          }
        }
        //debugger
        if(no=='no9'||no=='no10'||no=='no11'||no=='no12'||no=='no13') {
          //清空
          this.showStarData=[];
          if(deviceInfo!='') {
            let strArr1=[];
            strArr1=deviceInfo.split(';');
            for(let i=0;i<strArr1.length;i++) {
              let b={'status': '','text': ''};
              let a=strArr1[i].split(':')[0];
              if(i==0) {
                b.status='地锁';
              }
              if(i==1) {
                b.status='车位';
              }
              if(i==2) {
                b.status='充电';
              }
              if(a=='0') {
                b.text='空闲'
              } else {
                b.text='使用'
              }
              this.showStarData.push(b);
            }
            // strArr1.forEach((item,index) => {
            //     let b = {'status':'','text':''};
            //     let a =  item.split(':')[0];
            //     if(index == 0) {
            //         b.status = '地锁';
            //     }
            //     if(index == 1) {
            //         b.status = '车位';
            //     }
            //     if(index == 2) {
            //         b.status = '充电';
            //     }
            //     if(a=='0') {
            //         b.text = '空闲'
            //     }else {
            //         b.text = '使用'
            //     }
            //     this.showStarData.push(b);
            // })
          }
          this.showStar=true;
        }
      },
      goToWhere (no) {
        if(no=='no5'||no=='no14') {
          this.$router.push("/photovoltaic");
        }
        if(no=='no6') {
          this.$router.push("/energyStorage");
        }
      },
      //获取电站概况
      getPlantParams () {
        this.$api.plantApi.getPlantParams(this.nowUnit.id,res => {
          if(!isempty(res)) {
            this.plantParams.carbonValue=res.carbon;
            this.plantParams.sulfurValue=res.sulfur;
            this.plantParams.gfmianji=res.gfMianji;
            this.plantParams.gfzhujian=res.gfZhujian;
            this.plantParams.fuzhao=res.fuzhao;
            this.plantParams.qingxiejiao=res.qingxiejiao;
          }
        })

      },
      getCdzDayMaxLoad () {
        //获取充电桩日最大值
        this.$api.plantApi.getCdzDayMaxLoad(this.nowVariableName.cdz.join(','),(new Date()).getTime(),res => {
          this.maxDayLoad=res
        })
      },
      getCdzMonthMaxLoad () {
        //获取充电桩月最大值
        this.$api.plantApi.getCdzMonthMaxLoad(this.nowVariableName.cdz.join(','),(new Date()).getTime(),res => {
          this.maxMonthLoad=res
        })
      },

      changeHeight () {
        let lheight=document.getElementsByClassName("beijingse")[0]
        lheight.style.height=this.cnData.shengyurongliang+'%';
      },
      xList () {
        let list=[]
        for(let h=0,len=24;h<len;h++) {
          list.push((h<10? '0':'')+h+':00')
        }
        return list
      },
      changeTopTab (index) {
        this.indexed=index;
      },
      getDeviceRunInfo () {
        return
        //debugger
        if(!isempty(this.nowVariableName)) {
          let cdz='';
          if(!isempty(this.nowVariableName.cdz)) {
            cdz=this.nowVariableName.cdz.join(',')
          }
          let gf='';
          if(!isempty(this.nowVariableName.gf)) {
            gf=this.nowVariableName.gf.join(',')
          }
          let cn='';
          if(!isempty(this.nowVariableName.cn)) {
            cn=this.nowVariableName.cn.join(',')
          }
          if(cdz!=''||gf!=''||cn!='') {
            this.$api.plantApi.getDeviceRunInfo(cdz,gf,cn,(new Date()).getTime(),res => {
              //清空
              this.cdzRunLine=[];
              for(const key in res.cdz) {
                let cdzLineData=res.cdz[key][0].data;
                let newData=[];
                if(!isempty(cdzLineData)) {
                  for(let i=0;i<cdzLineData.length;i+=12) {
                    newData.push(cdzLineData[i]);
                  }
                }
                this.cdzRunLine.push({
                  data: newData,
                  name: key.substring(0,2),
                  type: 'line',
                  symbol: 'none',
                  lineStyle: {
                    normal: {
                      width: 3
                    }
                  },
                  smooth: true
                })
              }
              //设置充电桩运行曲线
              this.option3.series=this.cdzRunLine
              this.$refs.voption3.setData(this.option3)

              //用户负荷
              let sum={};
              let index=0;
              for(const key in res.yhfh) {
                index++
                let yhfhLineData=res.yhfh[key][0].data;
                let newData=[];
                if(!isempty(yhfhLineData)) {
                  for(let i=0;i<yhfhLineData.length;i+=12) {
                    newData.push(yhfhLineData[i]);
                  }
                  sum[index]=newData;
                }
              }
              //保存结果的数组
              let result=[];
              //保留两位小数数组
              let realResult=[];
              for(const key in sum) {
                //遍历数组每一项
                $.each(sum[key],function(index,val) {
                  if(isempty(result[index])) {
                    result[index]=0
                  }
                  result[index]+=val;
                })
              }
              for(let i=0;i<result.length;i++) {
                result[i]=result[i].toFixed(2)
              }

              //设置用户负荷
              let sur=[];
              sur.push({
                data: result.slice(0,(new Date()).getHours()+1),
                name: '用户负荷',
                itemStyle: {
                  normal: {
                    color: '#5f96f1',
                    lineStyle: {
                      color: '#5f96f1',
                      width: 3
                    }
                  }
                },
                type: 'line',
                symbol: 'none',
                smooth: true
              });
              this.option1.series=sur;
              this.$refs.voption1.setData(this.option1)
              //光伏逆变器发电负荷
              let fdSur=[]
              for(const key in res.fdfh) {
                let fdLineData=res.fdfh[key][0].data;
                let newData=[];
                for(let i=0;i<fdLineData.length;i+=12) {
                  newData.push(fdLineData[i]);
                }
                fdSur.push({
                  data: newData,
                  name: '上网负荷',
                  type: 'line',
                  symbol: 'none',
                  lineStyle: {
                    normal: {
                      width: 3
                    }
                  },
                  smooth: true
                })
                this.option2.series=fdSur;

              }
              //光伏每日发电量
              let dtfdl=[]
              for(const key in res.dtfd) {
                let dtfdData=res.dtfd[key][0].data;
                //把每日发电相加然后乘以系数
                let fdSum=0;
                dtfdData.forEach(item => {
                  if(item!=null) {
                    fdSum+=item
                  }
                })
                this.dyfdl=fdSum
                dtfdl.push({
                  data: dtfdData,
                  type: 'bar'
                })
              }

              this.option4.series=dtfdl;
              this.$refs.voption4.setData(this.option4)
              //光伏每年发电量
              let dnfdl=[]
              let dnfdlNewData=[]
              for(const key in res.dnfd) {
                let dnfdlData=res.dnfd[key];
                dnfdlData.forEach(item => {
                  if(item.data==null) {
                    dnfdlNewData.push(null);
                  } else {
                    let sum=0
                    for(let i=0;i<item.data.length;i++) {
                      sum+=(item.data)[i]
                    }
                    dnfdlNewData.push(sum);
                  }
                })
              }
              dnfdl.push({
                data: dnfdlNewData,
                type: 'bar',
                barWidth: 20
              })
              this.option5.series=dnfdl;
              this.$refs.voption5.setData(this.option5)
              //电池充放电功率
              let cngl=[];
              let cnNewData=[];
              for(const key in res.cngl) {
                let listData=res.cngl[key][0].data;
                for(let i=0;i<listData.length;i+=12) {
                  cnNewData.push(listData[i]);
                }
              }
              cngl.push({
                data: cnNewData,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                  normal: {
                    width: 3
                  }
                },
                smooth: true
              })
              this.option7.series=cngl
              this.$refs.voption7.setData(this.option7)
            })
          } else {
            this.option1.series=[];
            this.$refs.voption1.setData(this.option1,true)

            this.option3.series=[]
            this.$refs.voption3.setData(this.option3,true)

            this.option2.series=[]


            this.option4.series=[]
            this.$refs.voption4.setData(this.option4,true)

            this.option5.series=[]
            this.$refs.voption5.setData(this.option5,true)
            this.option7.series=[]
            this.$refs.voption7.setData(this.option7,true)
          }
        }
      },
      setValueNameList () {

        if(!isempty(this.nowUnit.id)) {
          this.$api.plantApi.getAllTypeVariableName(this.nowUnit.id,res => {
            //如果返回值为空就停掉,先停掉再设置  数据不会错
            //this.$store.plantStore.commit("setVariableNames",res);
            if(isempty(res)) {
              removeTask('getRealTimeValue')
            } else {
              //启动定时任务  可能被关了
              this.getValueNameList();
            }
            this.$store.plantStore.commit("setVariableNames",res);
            //更新后在调用各个曲线

            //设置高度
            this.changeHeight();
            this.getCdzMonthMaxLoad();
            this.getCdzDayMaxLoad();
            this.getPlantParams();
          });
        }
      },
      getValueNameList () {
        //马上开启定时任务
        addNewTask("getRealTimeValue",0,5000,-1,function() {
          debugPage.$store.plantStore.commit("getRealTimeValue")
        })
      },

    }
  }
</script>
<style scoped>
  .box_t {
    display: flex;
    justify-content: space-between;
    width: 90%;
    text-align: center;
    margin: 0 auto;
    padding-top: 30px
  }

  .tt span {
    font-size: .12rem;
  }

  .tt {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 6vw;
    height: 6vw;
    border: 1px solid #368ed9;
    border-radius: 50%;
    margin-right: 10px;
    justify-content: center;
  }

  #my_iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0;
    background: #333;
    margin: 0px;
  }

  /*body {*/
  /*    overflow: hidden;*/
  /*    margin: 0px;*/
  /*}*/

  .left {
    position: absolute;
    z-index: 2;
    background-color: #000;
    padding: 1em;
    width: 400px;
  }

  #layer {
    display: none;
    width: 1px;
    height: 1px;

    z-index: 99;
    position: absolute;
    color: #fff;

  }

  #text1,
  #text2 {
    width: 100%;
    color: #fff;
    /*display: none;*/
    /*width: 100px;*/
    /*height: 100px;*/
    /*background: #00000066;*/
    /*position: relative;*/
    /*top: -120px;*/
    /*left: -50px;  border: 2px solid #111;*/
    /*border-radius: 5px;*/
    /*padding: .5em;*/
  }

  #text {
    width: 150px;
    /*height: 100px;*/
    background: #00000066;
    position: relative;
    top: -120px;
    left: -50px;
    border: 2px solid #e0883e;
    border-radius: 5px;
    padding: .5em;
    text-align: center;
  }

  /* .heng {
    display: block;
    height: 2px;
    width: 75%;
    background: -webkit-gradient(linear, right top, left top, from(rgba(2, 229, 158, 0.18)), color-stop(#18c7a3), to(rgba(2, 229, 158, 0.18)));
    background: linear-gradient(to left, rgba(2, 229, 158, 0.18), #18c7a3, rgba(2, 229, 158, 0.18));
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .shu {
    display: block;
    height: 50%;
    width: 2px;
    background: linear-gradient(to top, rgba(2, 229, 158, 0.18), #18c7a3, rgba(2, 229, 158, 0.18));
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%);
  } */

  .box {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
    transform: translateY(-50%);
    position: absolute;
    top: 50%;
    justify-content: space-around;
  }

  .box .li {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 13px 0;
  }

  .box .li .r {
    width: 59%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .box .li .r .num {
    color: #368ed9;
    font-size: 16px;
    font-weight: bold;
  }

  .infoTitle {
    margin: 35px 0 20px 30px;
  }

  .infoContent {
    display: flex;
    width: 270px;
    margin: 0 auto;
    flex-wrap: wrap;
  }

  .infoItem {
    margin: 10px;
    width: 110px;
    height: 110px;
    border: 1px solid #368ed9;
    border-radius: 50%;

    text-align: center;
  }

  .infoItem>p {
    margin-top: 15px;
  }

  .infoItemImg {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    padding-top: 5px;
  }

  .infoItemImg>img {
    width: 100%;
  }

  .active {
    background: #4773ab !important;
  }

  .kanbanContainer {
    background: url('../../../public/static/image/dekan/denken.png');
    /* background-color: #304156; */
    background-size: 100% 100%;
    color: #fff;
    padding: 10px;
  }

  .flexBetween1 {
    display: flex;
    justify-content: space-between;
  }

  .kanBanTop {
    height: 700px;
    overflow: hidden;
  }

  .titleText {
    padding: 10px 0 10px 30px;
    font-size: 20px;
  }

  .dianchimao {
    width: 30px;
    margin: 0 auto;
    height: 5px;
    border-radius: 5px 5px 0 0;
    background: #9ea29d;
  }

  .chisheng {
    width: 80px;
    height: 130px;
    border: 3px solid #9ea29d;
    border-radius: 10px;
    position: relative;
  }

  .beijingse {
    position: absolute;
    bottom: 0;
    height: 100px;
    width: 102%;
    background: #76ac18;
    border-radius: 0 0 5px 5px;
    transform: translateX(-1px);
  }

  .rongliang {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    z-index: 1;
    position: relative;
    top: 43%;
  }

  .left-3 {
    padding-bottom: 20px;
  }

  .rightTopTab {
    width: 20%;
    margin-left: 5px;
    transform: skewX(-30deg);
    background: #304156;
  }

  .rightTopTab1 {
    transform: skewX(30deg);
    text-align: center;
    line-height: 30px
  }

  .bottomText {
    margin-bottom: 33px;
  }

  .bottomText>span {
    font-size: 14px;
  }

  .yongdianliang {
    background-image: url('../../../public/static/image/dekan/bg1.png');
    background-size: 100% 100%;
  }

  .leftBottom {
    background-image: url('../../../public/static/image/dekan/bg2.png');
    background-size: 100% 100%;
    padding: 10px;
  }

  .topP {
    padding: 5px 0 5px 10px;
  }

  .bottomP {
    text-align: right;
    padding: 0 20px 5px 0;
    font-size: 16px;
  }

  .plantImg {
    /*background-image: url('../../../public/static/image/dekan/bg3.png');*/
    /*background-size: 100% 100%;*/
    position: relative;
  }

  .leftInfoTop {
    margin-bottom: 30px;
  }
</style>